// @ts-nocheck
import { t } from "../i18n";
import { mapState } from "./state";

let pendingLoadRetry: (() => void) | null = null;

export function setPendingCemeteryLoadRetry(retry: (() => void) | null): void {
  pendingLoadRetry = retry;
}

const VEIL_ID = "map-loading-veil";

function ensureVeil(): HTMLElement {
  let veil = document.getElementById(VEIL_ID);
  if (veil) return veil;

  veil = document.createElement("div");
  veil.id = VEIL_ID;
  veil.className = "map-loading-veil map-loading-veil--error";
  veil.innerHTML = `
    <div class="map-loading-veil__panel">
      <p class="map-loading-veil__text">${t("map.loadError")}</p>
    </div>
  `;
  const viewport = document.getElementById("viewport");
  if (viewport) viewport.appendChild(veil);
  return veil;
}

export function showMapLoadingError(onRetry: () => void): void {
  const veil = ensureVeil();
  veil.style.display = "flex";
  const text = veil.querySelector(".map-loading-veil__text");
  if (text) text.textContent = t("map.loadError");

  if (!veil.querySelector(".map-loading-veil__retry")) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "map-loading-veil__retry";
    btn.textContent = t("map.retry");
    btn.addEventListener("click", onRetry);
    veil.querySelector(".map-loading-veil__panel")?.appendChild(btn);
  }
}

export function hideMapLoadingVeil(): void {
  const veil = document.getElementById(VEIL_ID);
  if (!veil) return;
  veil.style.display = "none";
}

/** Show error overlay only; loading state keeps the garden visible with placeholders. */
export function revealMapLoadingIfNeeded(): void {
  if (mapState.cemeteryLoadState === "ready") {
    hideMapLoadingVeil();
    return;
  }

  if (mapState.cemeteryLoadState === "error" && pendingLoadRetry) {
    showMapLoadingError(pendingLoadRetry);
  }
}

export function initGardenChrome(): void {
  const themeColor = document.querySelector('meta[name="theme-color"]');
  if (themeColor) themeColor.setAttribute("content", "#afd089");

  revealMapLoadingIfNeeded();
}
